<!-- 小区治理 -->
<template>
  <a-row :gutter="24" class="new-row">
    <a-col :md="collapsed ? 0 : 5" :sm="24" class="new-col">
      <a-row :gutter="10" class="new-row">
        <a-card :bordered="false" class="new-tree-card">
          <AreaTreeCard
            ref="areaTreeCard"
            :area-loading="areaLoading"
            :area-tree="areaTree"
            :curr-selected="currSelected"
            @node-selected="handleNodeSelected"
            @node-unselected="handleNodeUnselected"
            @unselect="resetAareaData"
            @collapse-all="collapseAll"
            @area-add="handleAreaAdd"
            @add-child="handleAdd"
            @delete="handleDelete"
            @toggle-visibility="handleTreeToggle"
          />
        </a-card>
      </a-row>
    </a-col>
    <a-col :md="collapsed ? 24 : 19" :sm="24" style="position: relative; padding-left: 30px" class="new-col">
      <a-icon
        :type="collapsed ? 'caret-right' : 'caret-left'"
        @click="collapsed = !collapsed"
        class="area-collapsed"
      ></a-icon>
      <a-card :bordered="false">
        <!-- 查询区域 -->
        <div class="table-page-search-wrapper">
          <a-form layout="inline" @keyup.enter.native="searchQuery">
            <a-row :gutter="24">
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item :label="$t('月份')">
                  <a-month-picker
                    v-model="queryParam.date"
                    value-format="YYYY-MM"
                    :placeholder="$t('请选择月份')"
                    style="width: 100%"
                  />
                </a-form-item>
              </a-col>
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
                  <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
                  <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
                </span>
              </a-col>
            </a-row>
          </a-form>
        </div>
        <!-- 查询区域-END -->

        <!-- table区域-begin -->
        <div>
          <a-table
            ref="table"
            size="middle"
            :scroll="{ x: true }"
            bordered
            rowKey="id"
            :columns="columns"
            :dataSource="dataSource"
            :pagination="ipagination"
            :loading="loading"
            class="j-table-force-nowrap"
            @change="handleTableChange"
          >
            <span slot="action" slot-scope="text, record, index">
              <a @click="handleGovernance(record, index)">{{ $t('发起整治') }}</a>
            </span>
          </a-table>
        </div>
      </a-card>
    </a-col>
  </a-row>
</template>
    
    <script>
import '@/assets/less/TableExpand.less'
import { mixinDevice } from '@/utils/mixin'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { getAction } from '@/api/manage'
import { AreaChoosetMixin } from '@/mixins/AreaChooseMixin'
import AreaTreeCard from '../AreaTreeCard.vue'
import moment from 'moment'
export default {
  name: 'CommunityGovernance',
  mixins: [JeecgListMixin, AreaChoosetMixin, mixinDevice],
  components: {
    AreaTreeCard
  },
  data() {
    return {
      description: '小区治理',
      collapsed: false,
      url: {
        list: '/jeecg-charge/wq/emfFlowAnalyzeMonth/list',
        start: '/mock/CommunityGovernance/start',
        // 区域ID->Area实体 Map(用于回填分区名称/用户数)
        queryAreaMap: '/jeecg-gis/area/areaIdToAllMapCache',
      },
      // gisAreaId -> Area 缓存
      areaMap: {},
      areaMapLoaded: false,
    }
  },
  created() {
    // 默认查询上个月(本月数据尚未生成)
    this.queryParam.date = moment().subtract(1, 'months').format('YYYY-MM')
    // 进入页面预加载区域 Map
    this.loadAreaMap()
  },
  computed: {
    // i18n：表头使用 computed 以响应语言切换
    columns() {
      return [
        {
          title: this.$t('排名'),
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: (t, r, index) => {
            return parseInt(index) + 1
          },
        },
        {
          title: this.$t('分区名称'),
          align: 'center',
          dataIndex: 'partitionName',
        },
        {
          title: this.$t('小区名称'),
          align: 'center',
          dataIndex: 'communityName',
        },
        {
          title: this.$t('月份'),
          align: 'center',
          dataIndex: 'recordMonth',
        },
        {
          title: this.$t('总分差水量(m³)'),
          align: 'center',
          dataIndex: 'supplySubUsageQuantity',
        },
        {
          title: this.$t('总分表差率(%)'),
          align: 'center',
          dataIndex: 'leakageBaseRate',
        },
        {
          title: this.$t('上月总分差(m³)'),
          align: 'center',
          dataIndex: 'lastMonthLeakageBaseRate',
        },
        {
          title: this.$t('环比率(%)'),
          align: 'center',
          dataIndex: 'monthOnMonthLbr',
        },
        {
          title: this.$t('治理意见'),
          align: 'center',
          dataIndex: 'suggestion',
        },
        {
          title: this.$t('发起时间'),
          align: 'center',
          dataIndex: 'checkDate',
        },
        {
          title: this.$t('物理漏损'),
          align: 'center',
          dataIndex: 'physicalLeakageRate',
        },
        {
          title: this.$t('管理漏损'),
          align: 'center',
          dataIndex: 'adminLeakageRate',
        },
        {
          title: this.$t('总表水量(m³)'),
          align: 'center',
          dataIndex: 'supplyQuantity',
        },
        {
          title: this.$t('分表水量(m³)'),
          align: 'center',
          dataIndex: 'usageQuantity',
        },
        {
          title: this.$t('用户数'),
          align: 'center',
          dataIndex: 'userNumber',
        },
        {
          title: this.$t('抄见率(%)'),
          align: 'center',
          dataIndex: 'meterReadingRate',
        },
        {
          title: this.$t('合理夜间最小水量(m³)'),
          align: 'center',
          dataIndex: 'mnfNormal',
        },
        {
          title: this.$t('平均夜间最小水量(m³)'),
          align: 'center',
          dataIndex: 'mnfActual',
        },
        {
          title: this.$t('KL值'),
          align: 'center',
          dataIndex: 'kl',
        },
        {
          title: this.$t('操作'),
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          width: 150,
          scopedSlots: { customRender: 'action' },
        },
      ]
    },
  },
  methods: {
    // 查询小区治理月数据列表
    async loadData(arg) {
      if (!this.currSelected || !this.currSelected.id) {
        this.dataSource = []
        this.ipagination.total = 0
        return
      }
      if (arg === 1) {
        this.ipagination.current = 1
      }
      try {
        this.loading = true
        let params = {
          gisAreaId: this.currSelected.id,
          pageNo: this.ipagination.current,
          pageSize: this.ipagination.pageSize,
        }
        if (this.queryParam.date) {
          params.recordMonth = this.queryParam.date
        }
        const res = await getAction(this.url.list, params)
        if (res.code == 200 || res.success) {
          const result = res.result || {}
          this.dataSource = result.records || []
          this.ipagination.total = result.total || 0
          // 用区域 Map 回填分区名称、用户数
          this.fillAreaInfo()
        } else {
          this.dataSource = []
          this.ipagination.total = 0
          this.$message.error(res.message || this.$t('获取数据失败'))
        }
      } catch (err) {
        console.log('查询小区治理数据失败:', err)
        this.dataSource = []
        this.ipagination.total = 0
      } finally {
        this.loading = false
      }
    },
    // 加载 区域ID -> Area Map(进页面加载一次)
    async loadAreaMap() {
      try {
        const res = await getAction(this.url.queryAreaMap)
        // 兼容 Result 包装 与 直接返回 Map 两种形态
        const map = (res && res.result) ? res.result : res
        this.areaMap = map || {}
        this.areaMapLoaded = true
        // 若列表已加载,补填一次
        if (this.dataSource && this.dataSource.length) {
          this.fillAreaInfo()
        }
      } catch (err) {
        console.log('加载区域Map失败:', err)
        this.areaMap = {}
        this.areaMapLoaded = false
      }
    },
    // 按 gisAreaId 回填分区名称(partitionName)与用户数(userNumber)
    fillAreaInfo() {
      if (!this.dataSource || !this.dataSource.length) return
      this.dataSource.forEach(item => {
        const area = this.areaMap[item.gisAreaId]
        if (area) {
          this.$set(item, 'partitionName', area.name)
          this.$set(item, 'userNumber', area.customerCount)
        }
      })
    },
    // 选择左侧区域节点，触发列表查询
    handleNodeSelected(record) {
      this.currSelected = record
      this.loadData(1)
    },
    handleNodeUnselected() {
      this.currSelected = {}
      this.dataSource = []
      this.ipagination.total = 0
    },
    // 区域树编辑相关事件占位，本页面为只读分析页
    handleAreaAdd() {},
    handleAdd() {},
    handleDelete() {},
    handleTreeToggle() {},
    // 重置查询条件(恢复上个月)
    searchReset() {
      this.queryParam = { date: moment().subtract(1, 'months').format('YYYY-MM') }
      this.loadData(1)
    },
    handleGovernance(record, index) {
      setTimeout(() => {
        this.$set(this.dataSource[index], 'checkDate', moment().format('YYYY-MM-DD'))
        this.$message.success(this.$t('发起治理成功'))
      }, 1000)
    },
  },
}
</script>
    <style scoped>
@import '~@assets/less/common.less';
</style>